export const SET_NOTIFICATIONS_DATA = 'SET_NOTIFICATIONS_DATA';
export const SET_TOOLTIP_TOGGLE = 'SET_TOOLTIP_TOGGLE';
export const SET_AUTOMATED_PAYMENTS_STATE = 'SET_AUTOMATED_PAYMENTS_STATE';
